import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess } from "@/store/Crud/functions/getters";
export const getUnseenCount = (state) => state.dataList.filter((doc) => !doc.seenByStudent && Boolean(!doc?.costBearerDocument)).length;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getUnseenCount,
    getId,
};
